import { Container, Row, Col, Button } from "react-bootstrap";
import "./HeroSection.css";
import TeacherImage from "../Imge/file_00000000beac7246953685b1c87ca46c.png"; // Real professional photo of the teacher
import { FaYoutube, FaFacebookF, FaGraduationCap } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export default function HeroSection() {
  const navigate = useNavigate();

  const handleRegisterClick = () => {
    navigate("/register");
  };

  return (
    <div className="hero-section">
      <Container className="hero-container relative">
        <Row className="align-items-center py-4 py-lg-5">
          {/* Right Column (RTL order): Teacher Image & Bio Card */}
          <Col lg={5} className="d-flex flex-column align-items-center justify-content-center order-2 order-lg-1 position-relative hero-left-col">
            <div className="teacher-graphics-container position-relative">
              {/* Spirograph SVG */}
              <svg className="bg-spiral" viewBox="0 0 200 200" fill="none">
                {Array.from({ length: 24 }).map((_, i) => (
                  <ellipse
                    key={i}
                    cx="100"
                    cy="100"
                    rx="80"
                    ry="35"
                    stroke="var(--brand-200-alt)"
                    strokeWidth="0.75"
                    transform={`rotate(${i * 7.5} 100 100)`}
                    opacity="0.35"
                  />
                ))}
              </svg>
              
              <div className="teacher-circle-frame">
                <img src={TeacherImage} alt="الأستاذ محمود الصبروط" className="teacher-circle-img" />
              </div>
            </div>

            {/* Who is Mr. Mahmoud El-Sabrout Card */}
            <div className="bio-card text-end mt-4">
              <h5 className="bio-card-title">مين مستر محمود الصبروط؟</h5>
              <p className="bio-card-text">
                أنا محمود عبد اللطيف الصبروط، خريج كلية اللغة العربية بجامعة الأزهر الشريف، وحاصل على الدبلوم التربوي والدراسات العليا. أعمل في تدريس لغة الضاد منذ عام 2016، ومؤسس قناة نوح التعليمية وصاحب فكرة «نُوحٌ نَحوَ نَحوٍ جَدِيدٍ» و«الهندسة النحوية» المعتمدة على معادلات مبتكرة لتثبيت أصعب القواعد بأسلوب شيق وممتع.
              </p>
            </div>
          </Col>

          {/* Left Column (RTL order): Hero Content & Stats */}
          <Col lg={7} className="hero-content-col text-end order-1 order-lg-2 d-flex flex-column justify-content-center">
            <div className="hero-header-badge mb-3 align-self-start">
              <span className="heart-emoji">✨</span> نُوحٌ نَحوَ نَحوٍ جَدِيدٍ ..
            </div>
            
            <h1 className="hero-main-title">
              منصة مستر <span className="gold-text">محمود الصبروط</span>
            </h1>
            
            <p className="hero-subtitle">
              المنصة التعليمية المتخصصة في شرح فروع اللغة العربية لطلاب الثانوية العامة والأزهرية، بأسلوب يجمع بين التبسيط والعمق الأكاديمي.
            </p>

            <div className="mb-4 d-flex justify-content-center justify-content-lg-start">
              <Button 
                onClick={handleRegisterClick} 
                className="btn-hero-register"
              >
                أنشئ حسابك الآن!
              </Button>
            </div>

            {/* Stats Area */}
            <div className="stats-section mt-3">
              <h5 className="stats-heading mb-4">طلاب اليوم .. قادة الغد!</h5>
              <div className="stats-grid">
                <div className="stat-card">
                  <div className="stat-icon-wrapper facebook">
                    <FaFacebookF />
                  </div>
                  <div className="stat-info">
                    <div className="stat-number">150K+</div>
                    <div className="stat-label">عيلتنا على فيسبوك</div>
                  </div>
                </div>

                <div className="stat-card">
                  <div className="stat-icon-wrapper youtube">
                    <FaYoutube />
                  </div>
                  <div className="stat-info">
                    <div className="stat-number">250K+</div>
                    <div className="stat-label">عيلتنا على اليوتيوب</div>
                  </div>
                </div>

                <div className="stat-card">
                  <div className="stat-icon-wrapper student">
                    <FaGraduationCap />
                  </div>
                  <div className="stat-info">
                    <div className="stat-number">25K+</div>
                    <div className="stat-label">طالب حققوا التميز</div>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
